import { getPatientEncountersById, getPatientMasterData, getPayerActivities } from '../../actions/PatientActions';
import { alertConfirmation, base64Decode, showFormatedDate, showFormattedTime, BEHAVIOR_BLOSSOMS, EBS, NE_ABA, BESTABA, DEMO, CBG, AIP, BUILDABLOCKTHERAPY, SWANCONSULTINGINC, CAS, VICTORIOUSLEARNING, ABAORLANDO, POSITIVEBEHAVIORSTEPS, SOAR, HYPERIONCENTER, HELPINGHANDS, FUTURES, TFABA, IAT } from '../../../../actions/utilAction';
import Alert from 'react-s-alert';
import classNames from 'classnames';
import { CommonButton } from '../../../../components/buttons';
import { connect } from 'react-redux';
import PatientInfo from '../../patient_info';
import React from 'react';
import history from '../../../../history';
import PaginatorCustom from '../../../../components/paginationCustom';
import SortingCustom from '../../../../components/SortingCustom';
import moment from 'moment';
import { Field, reduxForm, reset } from 'redux-form';
import { renderAutoCompleteSingleSelect, renderDateField, renderTextField } from '../../../../components/reduxFields';
import GlobalVariables, { resetFiltersAndSorting } from '../../../../actions/utilAction';

class Encounter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      appointmentId: null,
      encounterId: null,
      // allergies: [],
      includedData: [],
      allergyData: null,
      patientid: props.match.params.id ? base64Decode(props.match.params.id) : null,
      allergyId: null,
      // meta_data: null,
      AppointmentType: null,
      StaffName: null,
      Status: null,
      FromDate: null,
      ToDate: null,
      StatusTypes: [{ id: 1, value: 'Pending' }, { id: 2, value: 'Rendered' }],
    };

    this.filter = {
      sortColumn: 'id',
      sortOrder: 'desc',
      Status: '',
    };
    this.handleBack = this.handleBack.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleSearchEncounterDetails = this.handleSearchEncounterDetails.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
  }
  loadData(pageNumber) {
    let searchObj = {
      sort_fields: this.filter.sortColumn ? this.filter.sortColumn : 'id',
      sort_order: this.filter.sortOrder ? this.filter.sortOrder : 'desc',
      filters: { patientid: this.state.patientid },
      contain_filters: { appointmentType: this.state.AppointmentType ? this.state.AppointmentType : null,
        staffName: this.state.StaffName ? this.state.StaffName : '',
        status: this.state.Status ? this.state.Status : '',
        fromDate: this.state.FromDate ? this.state.FromDate : '',
        toDate: this.state.ToDate ? this.state.ToDate : '',
        actionName: "PatientEncounter",
       },
      pageNumber: pageNumber ? pageNumber : 1,
      pageSize: GlobalVariables.PageSize,      
    };

    this.props.getPatientEncountersById(searchObj);
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sortColumn = col_name;
      this.filter.sortOrder = col_order;
      this.loadData();
    }
  }

  componentWillMount() {
    let masterData = {
      'masterdata': 'appointmentType',
    };
    this.props.getPatientMasterData(masterData);
    this.loadData();
  }

  handleBack = () => {
    Alert.closeAll();
    this.setState({ open: false, appointmentId: null, encounterId: null });
    this.loadData();
  };

  handleViewClick=(event, obj) => {
    Alert.closeAll();

    // let encounterRouteName = `soap-encounter`; 
    let encounterRouteName = `client-customsession-soap-encounter`; 

    let path = `/${encounterRouteName}/${obj.patientAppointmentId}/${obj.id}`;
    if (obj.isBillableEncounter) {
      if(this.props.agencyName.toUpperCase() === BEHAVIOR_BLOSSOMS)
      {
        if(obj.notetypeId === 101){      
          path = `/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else if(obj.notetypeId === 102){      
          path = `/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else {
          path = `/session-encounter-behaviorblossoms/${obj.patientAppointmentId}/${obj.id}`;
        }
      }
      else if(this.props.agencyName.toUpperCase() === DEMO || this.props.agencyName.toUpperCase() === BUILDABLOCKTHERAPY || this.props.agencyName.toUpperCase() === IAT)
      {
        if(obj.notetypeId === 101){      
          path = `/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else if(obj.notetypeId === 102){      
          path = `/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else {
          path = `/session-encounter-data-collection/${obj.patientAppointmentId}/${obj.id}`;
        }
      }
      else if(this.props.agencyName.toUpperCase().startsWith(EBS))
      {
          if(obj.notetypeId === 1){
            path = `/session-encounter-data-collection/${obj.patientAppointmentId}/${obj.id}`;
          } 
          else if(obj.notetypeId === 2){
            path = `/session-encounter-early-intervention/${obj.patientAppointmentId}/${obj.id}`;
          } 
          else if(obj.notetypeId === 3){
            path = `/session-encounter-delaware-ei-ebs/${obj.patientAppointmentId}/${obj.id}`;
          } 
          else if(obj.notetypeId === 4){
            path = `/session-encounter-ifsp-developmenttime-ebs/${obj.patientAppointmentId}/${obj.id}`;
          } 
          else if(obj.notetypeId === 5){
            path = `/session-encounter-illinois-evaluation-ebs/${obj.patientAppointmentId}/${obj.id}`;
          } 
          else if(obj.notetypeId === 6){
            path = `/session-encounter-illinois-ebs/${obj.patientAppointmentId}/${obj.id}`;
          } else if(obj.notetypeId === 101){      
            path = `/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`;            
          } else if(obj.notetypeId === 102){      
            path = `/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`;            
          }  
      }
      else if(this.props.agencyName.toUpperCase() === CBG)
      {
          if(obj.notetypeId === 1){
            path = `/session-encounter-cbg/${obj.patientAppointmentId}/${obj.id}`;
          }
          else if(obj.notetypeId === 2){
            path = `/progress-encounter-one/${obj.patientAppointmentId}/${obj.id}`;
          } else if(obj.notetypeId === 101){      
            path = `/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`;            
          } else if(obj.notetypeId === 102){      
            path = `/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`;            
          } 
      }
      else if(this.props.agencyName.toUpperCase() === AIP)
      {
        if(obj.notetypeId === 101){      
          path = `/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else if(obj.notetypeId === 102){      
          path = `/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else {
          path = `/session-encounter-aip/${obj.patientAppointmentId}/${obj.id}`;
        }
      }
      else if(this.props.agencyName.toUpperCase() === NE_ABA)
      {
        if(obj.notetypeId === 101){      
          path = `/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else if(obj.notetypeId === 102){      
          path = `/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else {
          path = `/session-encounter-ne-aba/${obj.patientAppointmentId}/${obj.id}`;
        }
      }
      else if(this.props.agencyName.toUpperCase() === POSITIVEBEHAVIORSTEPS)
      {
        if(obj.notetypeId === 101){      
          path = `/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else if(obj.notetypeId === 102){      
          path = `/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else {
          path = `/session-encounter-pbs/${obj.patientAppointmentId}/${obj.id}`;
        }
      }        
      else if(this.props.agencyName.toUpperCase() === BESTABA)
      {
        if(obj.notetypeId === 1){
          path = `/session-encounter-bt-bestaba/${obj.patientAppointmentId}/${obj.id}`;
        }
        else if(obj.notetypeId === 2){
          path = `/session-encounter-bcba-bestaba/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 101){      
          path = `/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else if(obj.notetypeId === 102){      
          path = `/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`;            
        } 
      }
      else if(this.props.agencyName.toUpperCase() === SWANCONSULTINGINC)
      {
        if(obj.notetypeId === 1){
          path = `/soap-encounter/${obj.patientAppointmentId}/${obj.id}`;
        }
        else if(obj.notetypeId === 2){
          path = `/session-encounter-psychological-swan/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 101){      
          path = `/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else if(obj.notetypeId === 102){      
          path = `/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`;            
        } 
      }
      else if(this.props.agencyName.toUpperCase() === CAS)
      {
        if(obj.notetypeId === 1){
          path = `/soap-encounter/${obj.patientAppointmentId}/${obj.id}`;
        }
        else if(obj.notetypeId === 2){
          path = `/progress-encounter-one/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 101){      
          path = `/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else if(obj.notetypeId === 102){      
          path = `/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`;            
        } 
      }
      else if(this.props.agencyName.toUpperCase() === VICTORIOUSLEARNING)
      {
        if(obj.notetypeId === 1){
          path = `/soap-encounter/${obj.patientAppointmentId}/${obj.id}`;
        }
        else if(obj.notetypeId === 2){
          path = `/progress-encounter-one/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 101){      
          path = `/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else if(obj.notetypeId === 102){      
          path = `/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`;            
        } 
      }
      else if(this.props.agencyName.toUpperCase() === ABAORLANDO)
      {
        if(obj.notetypeId === 1){
          path = `/soap-encounter/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 2){
          path = `/session-encounter-rbt-abaor/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 3){
          path = `/session-encounter-bcba-abaor/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 101){      
          path = `/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else if(obj.notetypeId === 102){      
          path = `/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`;            
        } 
      }
      else if(this.props.agencyName.toUpperCase() === SOAR)
      {
        if(obj.notetypeId === 1){
          path = `/soap-encounter/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 2){          
          path = `/session-encounter-assessment-soar/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 3){          
          path = `/session-encounter-directtherapy-soar/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 4){          
          path = `/session-encounter-bcbasupervision-soar/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 5){          
          path = `/session-encounter-familytreatment-soar/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 6){          
          path = `/session-encounter-diagnosticevaluation-soar/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 101){      
          path = `/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else if(obj.notetypeId === 102){      
          path = `/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`;            
        }  
      }
      else if(this.props.agencyName.toUpperCase() === HYPERIONCENTER)
      {
        if(obj.notetypeId === 1){
          path = `/soap-encounter/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 2){          
          path = `/session-encounter-hyperion/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 101){      
          path = `/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else if(obj.notetypeId === 102){      
          path = `/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`;            
        } 
      }
      else if(this.props.agencyName.toUpperCase() === HELPINGHANDS)
      {
        if(obj.notetypeId === 1){
          path = `/soap-encounter/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 2){          
          path = `/session-supervision-encounter-helpinghands/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 101){      
          path = `/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else if(obj.notetypeId === 102){      
          path = `/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`;            
        } 
      }
      else if(this.props.agencyName.toUpperCase() === FUTURES)
      {
        if(obj.notetypeId === 1){
          path = `/soap-encounter/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 2){          
          path = `/session-psycheval-encounter-futures/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 3){          
          path = `/session-slpeval-encounter-futures/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 101){      
          path = `/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else if(obj.notetypeId === 102){      
          path = `/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`;            
        } 
      }
      else if(this.props.agencyName.toUpperCase() === TFABA)
      {
        if(obj.notetypeId === 1){
          path = `/soap-encounter/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 2){          
          path = `/session-encounter-rbt-tfaba/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 3){          
          path = `/session-encounter-bcba-tfaba/${obj.patientAppointmentId}/${obj.id}`;
        } else if(obj.notetypeId === 101){      
          path = `/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`;            
        } else if(obj.notetypeId === 102){      
          path = `/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`;            
        }  
      }
      else
      {        
          if(obj.notetypeId === 1){
            path = `/soap-encounter/${obj.patientAppointmentId}/${obj.id}`;
          } else if(obj.notetypeId === 101){      
            path = `/session-encounter-bt-default/${obj.patientAppointmentId}/${obj.id}`;            
          } else if(obj.notetypeId === 102){      
            path = `/session-encounter-bcba-default/${obj.patientAppointmentId}/${obj.id}`;            
          } 
      }
    } else {
        path = `/non-billable-soap-encounter/${obj.patientAppointmentId}/${obj.id}`;
    }
    history.push({
      pathname: path,
      state: { isRedirectFromPatientEncounter: true },
    });
    // this.setState({ open: true, appointmentId: obj.patientAppointmentId, encounterId: obj.id });
  };

  handleAlertClick=(event, encounterId) => {
    Alert.closeAll();
  };

  handleDeleteClick=(event, obj) => {
    alertConfirmation('Are you sure you want to delete encounter ?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.id,
      },
    });
  };

  handleReset = () => {
    Alert.closeAll();
    this.props.dispatch(reset('EncounterListing'));
    resetFiltersAndSorting(this.filter, 'id', true);
    // this.filter.Status = 'Pending';
    this.setState({ AppointmentType: null,
      StaffName: null,
      Status: null,
      FromDate: null,
      ToDate: null,
    }, () => {
      this.loadData();
    });
  };

  handleSearchEncounterDetails(event) {
  // event.preventDefault();
  // console.log('event............',event);
    if (!Object.keys(event).length) {
      return false;
    }
    this.setState({
      AppointmentType: event.AppointmentType ? event.AppointmentType : null,
      StaffName: event.StaffName ? event.StaffName : '',
      Status: this.state.Status || '',
      FromDate: event.FromDate ? showFormatedDate(event.FromDate) : '',
      ToDate: event.ToDate ? showFormatedDate(event.ToDate) : '',
    }, () => {
      this.loadData();
    });

  }


  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }

handleNewRequest = (input, selectedRecord) => {
  input.onChange(selectedRecord.value);
}

handleNewRequestStatus = (input, selectedRecord) => {
  // console.log('selectedRecord.......',selectedRecord.label);
  input.onChange(selectedRecord.value);
  // this.filter.Status = selectedRecord.label;
  this.setState({ Status: selectedRecord.label });
}
renderData() {
  if (this.props.encounters && this.props.encounters.data && this.props.encounters.data.length > 0) {
    return this.props.encounters.data.map((Obj, index) => {
      return (
        <tr key={Obj.id}>
          <td>{Obj.patientAppointmentId}</td>
          <td>{showFormatedDate(Obj.dateOfService)}{' (' + showFormattedTime(Obj.startDateTime) + ' - ' + showFormattedTime(Obj.endDateTime) + ')'}</td>
          <td>{Obj.duration}</td>
          <td>{Obj.staffName}</td>
          <td>{Obj.appointmentType}</td>
          <td className = {Obj.status === 'Pending' ? 'redfont' : Obj.status === 'Rendered' ? 'greenfont' : 'orangefont'}>{Obj.status}</td>
          {/* <td>{Obj.notes}</td> */}
          {this.props.viewPermission ?
            <td>
              <button onClick={(e) => this.handleViewClick(e, Obj)} type="button" title="View Session Note" className="tbactionbtn yellowfont"><i className="fa fa-eye" aria-hidden="true"></i></button>
            </td> : null
          }
        </tr>
      );
    });
  } else {
    return (
      <tr>
        <td colSpan="7">
          <div className="familydl text-center no-record">No record found.</div>
        </td>
      </tr>
    );
  }
};

renderEncounterListingData() {
  const { handleSubmit } = this.props;
  const tableClass = classNames({
    'table': true,
    'table-striped': this.props.condensed,
    'table-bordered': this.props.bordered,
    'table-hover': true,
    'table-condensed': this.props.condensed,
    'customtable': true,
  });
  return (
    <div className="readmin-panel">
      <div className="panel-body">
        <form className="readmin-form custom_form" onSubmit={ handleSubmit(this.handleSearchEncounterDetails)}>
          <div className="row">
            <div className="col-sm-4"></div>
          </div>
          <div className="row">
            <div className="col-sm-4 col-md-4 mt-35">
              <Field
                name="AppointmentType"
                label="Appointment Type"
                options={this.props.masterActivityType}
                handleNewRequest={this.handleNewRequest}
                component={renderAutoCompleteSingleSelect}
              />
            </div>
            <div className="col-sm-4 col-md-4">
              <Field name="StaffName"
                floatingLabelText="Staff Name"
                maxLength="50"
                onChange={this.handleSearchChange}
                component={renderTextField} />
            </div>
            <div className="col-sm-4 col-md-4 mt-35">
              <Field
                name="Status"
                label="Status"
                options={this.state.StatusTypes}
                handleNewRequest={this.handleNewRequestStatus}
                component={renderAutoCompleteSingleSelect}/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-6">
              <Field name="FromDate"
                placeholder="From Date"
                locale="en-US"
                selected={this.state.FromDate}
                onDateChange={this.onDateChange}
                openToYearSelection = {true}
                component={renderDateField} />
            </div>
            <div className="col-sm-6 col-md-6">
              <Field name="ToDate"
                placeholder="To Date"
                locale="en-US"
                selected={this.state.ToDate}
                onDateChange={this.onDateChange}
                openToYearSelection = {true}
                component={renderDateField} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 btn_rt reset-btn">
              <CommonButton className="grey_btn" type="Submit" primary={true} onTouchTap={this.handleSearchReadyToBillClaim} label = 'Filter'/>
              <CommonButton className="grey_btn ml_15" onTouchTap={this.handleReset} label = 'Reset'/>
            </div>
          </div>
        </form>
        <div className="row">
          <div className="col-sm-12 mt-20">
            <div>
              <div className="table-responsive">
                <table className={tableClass}>
                  {this.props.encounters && this.props.encounters.data && this.props.encounters.data.length ?
                    <thead>
                      <tr>
                        <th width="10%"><SortingCustom setSortColumn={this.setSortColumn} columnName='patientAppointmentId' displayName='Appoint.#'/></th>
                        <th width="24.28%"><SortingCustom setSortColumn={this.setSortColumn} columnName='dateOfService' displayName='Date Of Service'/></th>
                        <th width="10.28%">Duration</th>
                        <th width="14.28%"><SortingCustom setSortColumn={this.setSortColumn} columnName='staffName' displayName='Practitioner'/></th>
                        <th width="16%"><SortingCustom setSortColumn={this.setSortColumn} columnName='appointmentType' displayName='Appointment Type'/></th>
                        <th width="10%"><SortingCustom setSortColumn={this.setSortColumn} columnName='status' displayName='Status'/></th>
                        {/* <th width="10%">Notes</th> */}
                        {this.props.viewPermission ?
                          <th width="8%">Action</th>
                          : null
                        }
                      </tr>
                    </thead>
                    :
                    <thead>
                      <tr>
                        <th width="10%">Appoint.#</th>
                        <th width="24.28%">Date Of Service</th>
                        <th width="10.28%">Duration</th>
                        <th width="14.28%">Practitioner</th>
                        <th width="16%">Appointment Type</th>
                        <th width="10%">Status</th>
                        {/* <th width="10%">Notes</th> */}
                        {this.props.viewPermission ?
                          <th width="8%">Action</th>
                          : null
                        }
                      </tr>
                    </thead> }
                  <tbody>
                    {this.renderData()}
                  </tbody>
                </table>
              </div>
              {this.props.encounters && this.props.encounters.data && this.props.encounters.data.length ?
                <PaginatorCustom data={this.props.encounters.meta} handlePageChange={(pageNumber) => this.loadData(pageNumber)} />
                : null }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

render() {
  return (
    <div>
      <h2 className="page_title">Client Encounter</h2>
      <PatientInfo patientId={this.state.patientid} />
      <div className="clearfix"></div>
      {this.renderEncounterListingData()}
    </div>
  );
}
}

Encounter = reduxForm({
  form: 'EncounterListing',
})(Encounter);


function mapStateToProps(state) {
  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'CLIENT_ENCOUNTER_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }
  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
  let viewPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'CLIENT_ENCOUNTER_LIST_VIEW')[0].permission : false;
  // End For Role Permission
  // console.log('state.patient.encounters............',state.patient.encounters);
  return {
    encounters: state.patient.encounters,
    allergyData: state.patient.allergyData,
    patientMasterData: state.patient.patientMasterData,
    masterActivityType: state.patient.patientMasterData ? state.patient.patientMasterData.appointmentType : [],
    viewPermission: viewPermission,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}
export default connect(mapStateToProps, { getPatientMasterData, getPatientEncountersById, getPayerActivities })(Encounter);



// WEBPACK FOOTER //
// ./src/modules/patients/components/Encounter/index.js